import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LandingPageComponent } from './features/users/components/landing-page/landing-page.component';
import { HeaderComponent } from './shared/header/header.component';
import { FunnelComponent } from './features/users/components/funnel/funnel.component';
import { SharedModule } from './shared/shared.module';
import { VehicleDataComponent } from './features/users/components/funnel/vehicle-data/vehicle-data.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PickupComponent } from './features/users/components/funnel/pickup/pickup.component';
import { CatalogComponent } from './features/users/components/funnel/catalog/catalog.component';
import { HttpLoaderFactory } from '../translate-loader';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { RefuelingComponent } from './features/users/components/funnel/catalog/extra-steps/refueling/refueling.component';
import { WashComponent } from './features/users/components/funnel/catalog/extra-steps/wash/wash.component';
import { CatalogHomeComponent } from './features/users/components/funnel/catalog/extra-steps/catalog-home/catalog-home.component';
import { DefaultComponent } from './features/users/components/funnel/catalog/extra-steps/default/default.component';
import { SummaryComponent } from './features/users/components/funnel/summary/summary.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ExtrasComponent } from './features/users/components/funnel/extras/extras.component';
import { ModalExtraWashingComponent } from './features/users/components/funnel/extras/components/modal-extra-washing/modal-extra-washing.component';
import { ModalExtraRefillComponent } from './features/users/components/funnel/extras/components/modal-extra-refill/modal-extra-refill.component';
import { OverviewComponent } from './features/users/components/funnel/overview/overview.component';
import { PaymentComponent } from './features/users/components/payment/payment.component';
import { OwnershipChangeComponent } from './features/users/components/funnel/catalog/extra-steps/ownership-change/ownership-change.component';
import { ParkingComponent } from './features/users/components/funnel/catalog/extra-steps/parking/parking.component';
import { SuccessfulPaymentComponent } from './features/users/components/successful-payment/successful-payment.component';
import { ErrorPaymentComponent } from './features/users/components/error-payment/error-payment.component';
import { LoaderInterceptor } from './core/interceptor/loader.interceptor';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [
    AppComponent,
    LandingPageComponent,
    HeaderComponent,
    FunnelComponent,
    VehicleDataComponent,
    PickupComponent,
    CatalogComponent,
    RefuelingComponent,
    WashComponent,
    CatalogHomeComponent,
    DefaultComponent,
    SummaryComponent,
    ExtrasComponent,
    ModalExtraWashingComponent,
    ModalExtraRefillComponent,
    OverviewComponent,
    OwnershipChangeComponent,
    ParkingComponent,
    SuccessfulPaymentComponent,
    ErrorPaymentComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    ReactiveFormsModule,
    BsDatepickerModule,
    FormsModule,
    BrowserAnimationsModule,
    PaymentComponent,
    MatIconModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
],
  providers: [
    provideHttpClient(),
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { 
    constructor(private translate: TranslateService) {
    const savedLanguage = localStorage.getItem('language') || 'es';
    translate.setDefaultLang(savedLanguage);
    translate.use(savedLanguage);
  }
}
